export default __webpack_public_path__ + "static/media/small-diamond.648be344.svg";